// Curriculum "play next" presentation: turn the sequencer's suggestion into the
// entry id to load + the button text. Keeps main.ts's wiring thin.

import { nextSuggestion } from "../engine/sequencer";
import type { CatalogEntry } from "../songs/catalog";
import { skillLabel } from "../songs/skills";
import { masteredSongIds } from "../store/coach-progress";

/** The current suggestion's entry id + display text, or null when none. */
export function computePlayNext(
  catalog: readonly CatalogEntry[],
): { id: string; text: string } | null {
  const s = nextSuggestion({ catalog, masteredIds: masteredSongIds() });
  if (!s) return null;
  const verb = s.step === "teach" ? "learn" : "use";
  return { id: s.entry.id, text: `▶ Next: ${s.entry.title} — ${verb} ${skillLabel(s.skill)}` };
}
